import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";
import Home from "Routers/Home";
import Detail from "Routers/Detail";
import Header from "./Header";


// eslint-disable-next-line import/no-anonymous-default-export
export default ({ familyName }) => (


  <Router>
    <Header familyname={familyName} />
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path=":category" element={<Home />} />
      <Route path="/detail" element={<Detail />}>
        <Route path=":id" element={<Detail />} />
      </Route>

      <Route path="/cart" element={<Home />} />

      <Route path="/search" element={<Home />}>
        <Route path=":search" element={<Home />} />
      </Route>


    </Routes>
  </Router>
);
